<template>
  <vue-apex-charts
    :type="template"
    :height="height"
    :options="optionsData"
    :series="verticalAxisSeriesData"
  />
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import baseConfig from "../../../../baseConfig";
import axios from "@axios";

export default {
  name: "bar-line-area-chart",
  components: {
    VueApexCharts,
  },
  watch:{
    verticalAxisSeriesData(newValue) {
      this.verticalAxisSeriesData = newValue // Update when the prop changes
    },
    optionsData(newValue) {
      this.optionsData = newValue // Update when the prop changes
    }
  },
  props: {
    template: String,
    horizontalAxis: Array,
    verticalAxisSeries: Array,
    height: String,
    requestTime: String,
    requestAction: String,
  },
  mounted() {
    this.verticalAxisSeriesData = this.verticalAxisSeries
    if (this.requestAction!=='no')
      this.refresh()
  },
  methods: {
    async refresh() {
      setTimeout(this.refresh, parseInt(this.requestTime))
      if (this.do) {
        await axios.get(baseConfig.baseUrl + this.requestAction).then(async r => {
          this.verticalAxisSeriesData = r.data.verticalAxisSeries
          this.optionsData = r.data.optionsData
        })
      }
    }
  },
  destroyed(){
    this.do=0
    console.log("leave")
  },
  data() {
    return {
      do:1,
      verticalAxisSeriesData : [],
      optionsData: {
        chart: {
          id: 'vuechart-example'
        },
        xaxis: {
          categories: this.horizontalAxis
        }
      },
    }
  }
}
</script>

<style scoped>

</style>
